import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ConfiguracaoPage from './configuracao.page';
import * as commonActions from '../../app/common/common.action';
import { getUsuarioLocalStorage } from '../../localStorage.util';

class ConfiguracaoContainer extends Component {
  constructor() {
    super();
    this.state = {
      activeTab: '1',
    };
  }

  componentDidMount() {
    let usuarioLocalStorage = getUsuarioLocalStorage();
    if (usuarioLocalStorage === null) {
      this.props.history.push('/' + process.env.REACT_APP_LOGINPAGE);
    } else {
      this.props.commonActions.showFadeCarregando(false);
      this.setState({
        usuario: usuarioLocalStorage,
      });
    }
  }

  render() {
    return (
      <ConfiguracaoPage
        history={this.props.history}
        altura={window.innerHeight - 70}
        activeTab={this.state.activeTab}
        toggle={this.toggle.bind(this)}        
      ></ConfiguracaoPage>
    );
  }

  toggle(activeTab) {
    this.setState({
      activeTab: activeTab,
    });
  }
}

const mapStateToProps = (state) => {
  return {
    
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfiguracaoContainer);



// WEBPACK FOOTER //
// ./src/pages/configuracao/configuracao.container.js